import type {DominioTiempo} from "services-comun-meteored/modules/portal/tiempo";
import {datadogRum} from "@datadog/browser-rum";
import "services-comun/modules/types";

import config from "./utiles/config";

if (PRODUCCION && !TEST) {
    datadogRum.init({
        applicationId: '94eccf5d-9800-4a7f-b48d-f4c393d3b621',
        clientToken: 'pub7f920f08ee2b38cfc922ea5e813dcb30',
        site: 'datadoghq.eu',
        service: 'tiempo-www/javscript-src',
        env: 'prod',
        version: config.version,
        allowedTracingUrls: [
            config.endpoints.services,
            // config.endpoints.mr, // todo: no se puede habilitar hasta que todos los servicios utilizados por web actualicen su Framework y pasen 20 días
        ],
        // traceSampleRate: 20,
        // trackingConsent: "granted",
        // trackingConsent: "not-granted",
        trackSessionAcrossSubdomains: true,
        sessionPersistence: "local-storage",
        sessionSampleRate: 10,
        // investigate: 1%
        sessionReplaySampleRate: 0.01,
        defaultPrivacyLevel: 'mask-user-input',
        // trackViewsManually: true,
    });
    if (config.pv.enabled) {
        datadogRum.startView(config.pv);
        // https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm
        // datadogRum.setViewName('<VIEW_NAME>');
    }
}

import {Entry} from "./root/entry";

import(/* webpackChunkName: "site/[request]" */`services-comun-meteored/modules/portal/tiempo/dominios/${config.site}`)
    .then(module=>module.default)
    .then((dominio: DominioTiempo)=>{
        const entry = new Entry(document, config, dominio);

        {
            // Módulos de redacción
            if (config.cfg.news.enabled) {
                entry.add("redaccion/last");
            }
        }
        {
            // Módulos de contacto
            entry.add("contact/work", {
                selector: {
                    some: ["#enviarcv"],
                },
            });
        }
    });
